import React from "react";

import Placeholder, { Rect } from "@/components/Skeleton";

const DispensaryMenuItemCardSkeleton: React.FC = () => {
  return (
    <div
      data-testid="dispensary-menu-item-card-skeleton"
      className="relative bg-white shadow-low rounded p-lg mb-lg"
    >
      <div className="flex">
        <div className="flex flex-col mr-md basis-1/8">
          <Placeholder width="104" height="104">
            <Rect rx="3" ry="3" width="100%" height="100%" />
          </Placeholder>
        </div>
        <div className="flex flex-col mr-md grow basis-1/2">
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="25%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="90%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="40%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <div className="flex w-[100px]">
              <div className="mr-xs">
                <Placeholder width="100%" height="20">
                  <Rect rx="3" ry="3" width="100%" height="100%" />
                </Placeholder>
              </div>
              <div className="">
                <Placeholder width="100%" height="20">
                  <Rect rx="3" ry="3" width="100%" height="100%" />
                </Placeholder>
              </div>
            </div>
          </div>
          <div className="mb-lg">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="25%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="70%" height="100%" />
            </Placeholder>
          </div>
          <div className="">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="40%" height="100%" />
            </Placeholder>
          </div>
        </div>
        <div className="flex flex-col justify-end basis-1/4">
          <div className="mb-xs">
            <Placeholder width="100%" height="20">
              <Rect rx="3" ry="3" width="100%" height="100%" />
            </Placeholder>
          </div>
          <div className="mb-sm">
            <div className="flex w-[150px]">
              <div className="mr-xs">
                <Placeholder width="100%" height="20">
                  <Rect rx="3" ry="3" width="100%" height="100%" />
                </Placeholder>
              </div>
              <div className="">
                <Placeholder width="100%" height="20">
                  <Rect rx="3" ry="3" width="100%" height="100%" />
                </Placeholder>
              </div>
            </div>
          </div>
          <div className="">
            <Placeholder width="100%" height="40">
              <Rect rx="3" ry="3" width="100%" height="100%" />
            </Placeholder>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DispensaryMenuItemCardSkeleton;
